import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import ModalCreateIssuingEdge from "./ModalCreateIssuingEdge";
import ModalUpdateIssuingEdge from "./ModalDeleteOrdersInIssuingEdge";
import IssuingEdgeService from "../../../../../API/orders/prodaction.issueedge/issueedge/IssuingEdgeService";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import ModalConfirm from "../../../modal/ModalConfirm";
import NameModal from "../../../modal/NameModal";

const IssuingEdgesTable = ({
                               data,
                               setData,
                               tableOptions,
                               tableOptionsHandle,
                               handleModalAlert,
                               isArchive,
                               globalFilter,
                               handleSearchQuery,
                               filteredData,
                               columnsFilter
                           }) => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [updateModalOpen, setUpdateModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [issuedModal, setIssuedModal] = useState(false)
    const [editNumberModal, setEditNumberModal] = useState(false)

    const [change, setChange] = useState(false);
    const [showColumnFilters, setShowColumnFilters] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const createIssuingEdge = (ids, handleClose) => {
        setLoading(true)
        IssuingEdgeService.createByOrderIds(ids).then(function (response) {
            const newData = [...data, response.data]
            setData(newData);
            handleSearchQuery(globalFilter, newData)
            setChange(!change)
            handleModalAlert("Выдача создана", 'success')
            handleClose()
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    };

    const deleteOrdersInIssuingEdge = (ids) => {
        IssuingEdgeService.deleteOrderByIds(currentEditRowId, ids).then(function (response) {
            const newData = data.map(el => el.id === currentEditRowId ? response.data : el)
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            closeUpdateModal();
            handleModalAlert("Заказ удалён из выдачи", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'number',
                header: 'Номер',
                accessorKey: 'number',
                minSize: 8,
                maxSize: 8,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/issuing-edges/' + row.original.id + "/" + encodeURIComponent(row.original.number)}>
                        {cell.getValue() === null ? '' : cell.getValue()}
                    </Link>
                ),
            },
            {
                accessorFn: (row) => {
                    if (row.date === null) {
                    } else {
                        return new Date(row.date)
                    }
                },
                id: 'date',
                header: 'Дата поступления',
                sortingFn: 'datetime',
                maxSize: 25,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString();
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'orders',
                header: 'Заказы',
                accessorKey: 'orders',
                minSize: 1200,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
                maxSize: 2,
            },
        ];

        return baseColumns;
    }, [data, setData, filteredData]);

    const closeCreateModal = () => {
        setCreateModalOpen(false)
    };

    const closeUpdateModal = () => {
        setCurrentEditRowData(null);
        setCurrentEditRowId(null);
        setUpdateModalOpen(false)
    };
    const handleCloseEditNumber = () => {
        setCurrentEditRowData(null);
        setEditNumberModal(false)
    }

    const createIssuingEdgesTable = () => {
        setCreateModalOpen(true)
    };

    const handleUpdateModel = useCallback(
        (row) => {
            setCurrentEditRowData(row);
            setCurrentEditRowId(row.id);
            setUpdateModalOpen(true)
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const handleDeleteRow = useCallback(
        (row) => {
            IssuingEdgeService.delete(row.id)
                .then(function () {
                    const newData = data.filter(el => el.id !== row.id)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );
    const handleCloseIssuingModal = () => {
        setIssuedModal(false)
        setCurrentEditRowData(null)
    }
    const handleOpenIssuingModal = (row) => {
        setIssuedModal(true)
        setCurrentEditRowData(row)
    }
    const handleSetNumber = (row) => {
        setEditNumberModal(true)
        setCurrentEditRowData(row)
    }

    const handleCloseIssuing = () => {
        IssuingEdgeService.close(currentEditRowData?.id)
            .then(function () {
                const newData = data.filter(el => el.id !== currentEditRowData?.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Выдача закрыта", 'success')
                handleCloseIssuingModal()
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleOpenIssuing = () => {
        IssuingEdgeService.open(currentEditRowData?.id)
            .then(function () {
                const newData = data.filter(el => el.id !== currentEditRowData?.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Возвращено из архива", 'success')
                handleCloseIssuingModal()
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleEditNumberModal = (value) => {
            setLoading(true)
            IssuingEdgeService.setNumber(currentEditRowData?.id, value.name)
                .then(function () {
                    const newData = data.map(el => el.id === currentEditRowData?.id ? {...el, number: value.name} : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Номер изменён", 'success')
                    handleCloseIssuingModal()
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        },
        menuItem = isArchive
            ? [
                {type: "open", text: "Вернуть из архива", handler: handleOpenIssuingModal},
            ]
            : [
                {type: "edit", text: "Изменить", handler: handleUpdateModel},
                {type: "setNumber", text: "Переименовать", handler: handleSetNumber},
                {type: "delete", text: "Удалить", handler: handleDeleteRow},
                {type: "close", text: "Закрыть выдачу", handler: handleOpenIssuingModal},
            ]
    const navigate = useNavigate();
    return (
        <Box sx={{
            width: '1800px',
            overflow: 'auto',
            maxWidth: 'calc(100vw - 50px)',
        }}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px", gap: "20px"}}
            >
                {!isArchive && <ButtonCreate
                    text={"Создать выдачу материалов"}
                    width={270}
                    onClick={() => createIssuingEdgesTable()}
                />}
                {!isArchive && <ButtonCreate
                    text={"Архив"}
                    width={60}
                    icon={false}
                    onClick={() => navigate("/organization/issuing-edges-archive")}
                />}
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '1800px',
                        maxHeight: `calc(100vh - 420px)`
                    }
                }}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                        sx: () => ({
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',
                            },
                            "&:first-of-type": {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },

                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        })
                    })
                }}

                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                        "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                            "minWidth": "100%"
                        },
                        "& .MuiCollapse-root .MuiSelect-select": {
                            padding: "0 !important",
                            "& .MuiChip-label": {
                                paddingLeft: "5px",
                                paddingRight: "5px",
                            }
                        }

                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={(value) => {
                    handleSearchQuery(value, data, null)
                }}
                onColumnFiltersChange={(updater) => {
                    handleSearchQuery(updater(columnsFilter), data, null, true)
                }}
                onShowColumnFiltersChange={handleShowColumnFilters}
                state={{
                    showColumnFilters: showColumnFilters,
                    columnFilters: columnsFilter,
                    globalFilter: globalFilter,
                    showGlobalFilter: true,
                    pagination: tableOptions,
                }}
                manualFiltering={true}
                rowCount={tableOptions.totalElements}
                enableRowActions={true}
                enableToolbarInternalActions={false}
                columns={columns}
                data={filteredData}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 50},
                }}
                localization={MRT_Localization_RU}
                getRowId={(originalRow) => originalRow.id}
            />
            <ModalConfirm
                title={isArchive ? "Вернуть из архива?" : "Закрыть выдачу"}
                modalOpen={issuedModal}
                handleClose={handleCloseIssuingModal}
                handleSubmit={isArchive ? handleOpenIssuing : handleCloseIssuing}
                action={"Подтвердить"}
            />
            <ModalCreateIssuingEdge
                open={createModalOpen}
                onClose={closeCreateModal}
                titleModal={"Создать выдачу материалов"}
                createIssuingEdge={createIssuingEdge}
                change={change}
                setChange={setChange}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
            <ModalUpdateIssuingEdge
                open={updateModalOpen}
                onClose={closeUpdateModal}
                issuingEdgesId={currentEditRowId}
                titleModal={"Удалить заказы из выдачи"}
                deleteOrdersInIssuingEdge={deleteOrdersInIssuingEdge}
                handleModalAlert={handleModalAlert}
            />
            <NameModal
                title={"Изменить номер"}
                label={"Номер"}
                open={editNumberModal} onClose={handleCloseEditNumber}
                handleSubmit={handleEditNumberModal}
                initValue={{name: currentEditRowData?.number}}
                loading={loading}/>
        </Box>
    );
};

export default IssuingEdgesTable;